import {MOON_300} from '../../../../../../common/css/color.styles';

export const EVAL_DEF_HEIGHT = 45;
export const STANDARD_PADDING = 16;
export const BOX_RADIUS = '6px';
export const STANDARD_BORDER = `1px solid ${MOON_300}`;
export const PLOT_HEIGHT = 300;
export const PLOT_PADDING = 30;
export const SIGNIFICANT_DIGITS = 4;
export const PLOT_GRID_COLOR = MOON_300;
export const MIN_PLOT_DOT_SIZE = 10;
export const MAX_PLOT_DOT_SIZE = 25;
